import {getTranslation} from "../helpers/get-translation";

export const logoquizConfig = {
		apiKey: getTranslation("firestore_config_apiKey"),
		authDomain: getTranslation("firestore_config_authDomain"),
		databaseURL: getTranslation("firestore_config_databaseURL"),
		projectId: getTranslation("firestore_config_projectId"),
		storageBucket: getTranslation("firestore_config_storageBucket")
};